import { HttpErrorResponse, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { tap } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ApiError } from './api-error';
import { ApiErrorSnackBar } from './api-error-snack-bar/api-error-snack-bar';

export function isApiRequest(request: HttpRequest<unknown>): boolean {
  return request.url.startsWith(environment.apiUrl);
}

export function isApiErrorResponse(error: HttpErrorResponse['error']): error is ApiError {
  return error && 'code' in error && 'message' in error;
}

export const apiErrorInterceptor: HttpInterceptorFn = (req, next) => {
  const snackBar = inject(MatSnackBar);

  if (!isApiRequest(req)) {
    return next(req);
  }
  return next(req).pipe(
    tap({
      error: (res: HttpErrorResponse) => {
        if (isApiErrorResponse(res.error)) {
          snackBar.openFromComponent(ApiErrorSnackBar, {
            data: res.error,
            duration: 5000,
            panelClass: 'jp-error-snack-bar',
          });
        } else {
          snackBar.open('Désolé, une erreur inatendue est survenue.', 'OK', {
            duration: 5000,
            panelClass: 'jp-error-snack-bar',
          });
        }
      },
    }),
  );
};
